import lockedTokenContractAbi from "../../contracts/lockedTokenContractAbi.json";
import { ethers } from "ethers";
import Config from "../../api/Config";

const state = {
  lockedTokenTx: null,
  lockedTokenBalance: null,
  calcAbi: null,
  calcAddress: null,
  calcContractAddress: null,
  calcContract: null,
  signer: null
};

const getters = {
  getLockedTokenTx(state) {
    return state.lockedTokenTx;
  },
  getLockedTokenBalance(state) {
    return state.lockedTokenBalance;
  },
  getLockedTokenAbi(state) {
    return state.calcAbi;
  },
  getLockedTokenAddress(state) {
    return state.calcAddress;
  },
  getLockedTokenContract(state) {
    return state.calcContract;
  },
  getSigner(state) {
    return state.calcSigner;
  }
};

const actions = {
  async fetchLockedTokenContract({ dispatch, commit, rootState }) {

    let providerW3m = rootState.accounts.providerW3m;
    const provider = new ethers.providers.Web3Provider(providerW3m);
    const config = (await Config.getConfig()).data;
    // const provider = new ethers.providers.JsonRpcProvider(config.json_rpc_provider);
    let contractAddress = config.locked_token_contract_address;
    const signer = provider.getSigner();
    // const signer = new ethers.Wallet(privateKey, provider);
    const contract = new ethers.Contract(
      contractAddress,
      lockedTokenContractAbi,
      signer
    );

    commit("setLockedTokenContract", contract);
    commit("setLockedTokenContractAddress", contractAddress);
    commit("setSigner", signer);

    dispatch("updateLockedBalance");
  },
  async updateLockedBalance({ commit, state }) {
    if (state.calcContract) {

      const balance = await state.calcContract.balanceOf(await state.calcSigner.getAddress());

      commit("setLockedTokenBalance", parseFloat(ethers.utils.formatEther(balance)));

      return {
        balance
      };
    }
  },
  async lockTokens({ dispatch, state, rootState }, amount) {
    try {
      // Normalize amount (handle string with comma or dot, or number)
      const cleanStr = (amount || '').toString().trim().replace(',', '.');
      const numAmount = parseFloat(cleanStr);
      if (!cleanStr || isNaN(numAmount) || numAmount <= 0) {
        throw new Error("Invalid token amount to retire");
      }

      const parsedWei = ethers.utils.parseEther(cleanStr);
      let allowance = await rootState.tokenContract.calcContract.allowance(rootState.accounts.activeAccount, state.calcContractAddress);

      if (allowance.lt(parsedWei)) {
        await dispatch("tokenContract/approveAll", state.calcContractAddress, { root: true });
      }

      let tx = await state.calcContract.retire(parsedWei);

      await tx.wait();

      return tx;

    } catch (e) {
      const cleanStr = (amount || '').toString().trim().replace(',', '.');
      const numAmount = parseFloat(cleanStr) || 0;
      const currentBal = parseFloat(rootState.tokenContract.tokenBalance) || 0;

      if (currentBal < numAmount) {
        throw new Error("You don't have enough ZCO2 tokens.");
      } else if (e.data && e.data.message && e.data.message.includes("ERC20: insufficient allowance")) {
        throw new Error("Insufficient allowance, please approve the tokens and try again.");
      } else if (e.message && e.message.includes("429")) {
        throw new Error("The network RPC node is currently busy (HTTP 429). Please try again in a few seconds.");
      } else if (e.message && e.message.includes("HTTP client error")) {
        throw new Error("The network RPC provider returned a connection error. The transaction may have completed or needs a retry. Check your wallet activity.");
      } else {
        throw e;
      }
    }

  },
  sleep(s) {
    return new Promise(resolve => setTimeout(resolve, s * 1000));
  }
};

const mutations = {
  setLockedTokenTx(state, _lockedTokenTx) {
    state.lockedTokenTx = _lockedTokenTx;
  },
  setLockedTokenBalance(state, _lockedTokenBalance) {
    state.lockedTokenBalance = _lockedTokenBalance;
  },
  setLockedTokenAbi(state, abi) {
    state.calcAbi = abi;
  },
  setLockedTokenAddress(state, address) {
    state.calcAddress = address;
  },
  setLockedTokenContract(state, _contract) {
    state.calcContract = _contract;
  },
  setLockedTokenContractAddress(state, _contractAddress) {
    state.calcContractAddress = _contractAddress;
  },
  setSigner(state, _signer) {
    state.calcSigner = _signer;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
